export const showModal = (id) => {
    document.dispatchEvent(new CustomEvent('showModal', {
        detail: { id },
    }));
};
export const hideModal = (id) => {
    document.dispatchEvent(new CustomEvent('hideModal', {
        detail: { id },
    }));
};
